import React from 'react';
import { Empty, Card } from 'antd';

/**
 * 小程序骨架占位页（分销小程序 / 项目小程序 的三级页面）
 *
 * REQ 导航整合：业务模式新增「小程序管理」一级导航，分销/项目小程序先建导航骨架，
 * 具体页面功能后续迭代填充。此组件提供统一的「功能建设中」占位，避免菜单点进去白屏。
 */
interface PlaceholderProps {
  title: string;
  desc?: string;
}

const MiniProgramPlaceholder: React.FC<PlaceholderProps> = ({ title, desc }) => {
  return (
    <Card
      style={{ margin: 16, borderRadius: 'var(--fg-radius, 14px)', minHeight: 'calc(100vh - 160px)' }}
      styles={{ body: { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - 220px)' } }}
    >
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--fg-text, #1a2b22)' }}>{title}</div>
            <div style={{ marginTop: 8, color: 'var(--fg-text2, #6b8578)', fontSize: 13 }}>
              {desc || '功能建设中，敬请期待'}
            </div>
          </div>
        }
      />
    </Card>
  );
};

export default MiniProgramPlaceholder;
